import React from "react";

import Slider from "react-slick";
import LazyImage from "../Shared/LazyImage";

const ProductSlider = ({ images, className }) => {
    const prodSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    const renderSlider = () => {
        return (
            images &&
            images.map((image, index) => {
                return (
                    <div key={index} className="product-slider-items">
                        <LazyImage
                            src={
                                image ||
                                require("../../assets/images/prod-img.png")
                                    .default
                            }
                            alt="ProductImage"
                        />
                    </div>
                );
            })
        );
    };

    return (
        <>
            <Slider
                className={`grey-slider-buttons ${className}`}
                {...prodSettings}
            >
                {renderSlider()}
            </Slider>
        </>
    );
};

export default ProductSlider;
